import Blank from "@/layouts/blank.vue"

import ControlTower from "@/pages/admin/control-tower/ControlTower.vue";


const controlTowerRoutes = [
    {
        path: "control-tower",
        name: "app-admin-control-tower",
        component: Blank,
        children: [

            {
                path: "list",
                name: "app-admin-control-tower-list",
                component: ControlTower,
            },

        ]
    },
]

export default controlTowerRoutes